import Vue from 'vue';
import map from 'lodash/map';
import xorWith from 'lodash/xorWith';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import {filterApplicationsOrder} from '../../utils/helperFunctions';

const INIT_STATE = {
  brokers: [],
  brokerTabs: [],
  brokerTabApps: {},
};
const state = {
  ...INIT_STATE,
};

const helperFunctions = {
  isDiscontinued(app) {
    if (app.status === 'CANCELLED' || app.status === 'EXPIRED' || app.status === 'LOW SCORE' || app.status === 'NO SCORE' || app.status === 'DECLINED') {
      return app.status
    }
    return ''
  },
  mapBrokers(brokers) {
    const deactivated = (curStage) => {
      if (curStage === 'DEACTIVATED') {
        return 'Deactivated'
      }
      return ''
    }
    const stage = (curStage) => {
      switch (curStage) {
        case 'PRE_SIGN_UP':
          return 1;
        case 'PRE_AGREEMENT':
          return 2;
        case 'ACTIVE':
          return 3;
      }
    }

    return map(brokers, (indvBroker) => ({
      // these components are defined in table component
      name: {component: 'name', props: {name: indvBroker.name}},
      stage: {
        component: 'completed-steps',
        props: {
          length: 3,
          successMessage: 'Active',
          discontinued: deactivated(indvBroker.status),
          'current-step': stage(indvBroker.status),
        },
      },
      businessName: indvBroker.businessName,
      emailAddress: indvBroker.email,
      phoneNumber: indvBroker.mobileNumber,
      activeApplications: {component: 'active-apps', props: {number: indvBroker.count}},
      metaData: {id: indvBroker.id},
    }))
  },

  mapApplicationList(applications) {
    return map(filterApplicationsOrder(applications), (app) => {
      const broker = state.brokerTabs.filter(broker => broker.id === app.brokerId);
      const {name: brokerName} = broker && broker[0]
      return ({
        name: {component: 'name', props: {name: app.name}},
        stage: {
          component: 'completed-steps',
          props: {
            length: 5,
            successMessage: app.status,
            discontinued: helperFunctions.isDiscontinued(app),
            status: app.status,
            'current-step': app.stage,
          },
        },
        loanAmount: `$${app.amount}`,
        dateUpdated: moment(app.updatedAt).format('YYYY-MM-DD'),
        ownership: {component: 'dropdown-selector', props: {currentOwner: app.currentOwner, brokerName, appId: app.id}},
        actions: {
          component: 'action-cell',
          props: {stage: app.stage, applicationId: app.id, isCancelled: helperFunctions.isDiscontinued(app)},
        },
        metaData: {id: app.id},
      })
    })
  },
}

const getters = {
  getBrokerTabs(state) {
    return state.brokerTabs;
  },
  getBrokers(state) {
    return helperFunctions.mapBrokers(state.brokers);
  },
  getApplicationList: (state) => (brokerId) => {
    return helperFunctions.mapApplicationList(state.brokerTabApps[brokerId]);
  },
};

const actions = {
  async fetchBrokers({commit, state}, id) {
    try {
      // only make backend request for the first time
      if (state.brokers.length === 0) {
        const {body} = await Vue.http.get('aggregator/brokers')
        commit({type: 'setField', field: 'brokers', value: body.brokers});
      }
    } catch (e) {
      throw Error(e.message)
    }
  },
  async fetchBrokersApplications({commit, state}, {id, refetch}) {
    try {
      // only make backend request for the first time or if refetch is forced
      if (!state.brokerTabApps[id] || refetch) {
        const {body} = await Vue.http.get(`app/applications?brokerId=${id}`)
        // const applicationsList = helperFunctions.mapApplicationList(body.applications);
        commit({type: 'toggleBrokerTabApp', id, applicationsList: body.applications});
      }
    } catch (e) {
      throw Error(e.message)
    }
  },
  async changeOwnership({commit, state}, {appId, newOwner}) {
    try {
      const {body} = await Vue.http.post(`aggregator/change-ownership`, {appId, newOwner})

      if (body) {
        return true;
      }
    } catch (e) {
      throw Error(e.message)
    }
  },
};

const mutations = {
  setField(state, payload) {
    state[payload.field] = payload.value;
  },
  setFields(state, payload) {
    state = Object.assign(state, payload.values);
  },
  resetState(state) {
    Object.assign(state, INIT_STATE);
  },
  toggleBroker(state, payload) {
    state.brokerTabs = xorWith(state.brokerTabs, [payload], isEqual)
  },
  toggleBrokerTabApp(state, payload) {
    state['brokerTabApps'] = {...state['brokerTabApps'], [payload.id]: payload.applicationsList}
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/brokers.js